
import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import HttpClient from "src/http/http-client";

/**
 * 报告服务
 * @class
 * @version 1.0.0
 */
export default class ReportService extends ServiceBase
{
    /*
     * 报告服务实例
     * @private
     * @return ReportService
     */
     private static _instance: ReportService;

     /**
      * 报告实例
      * @static
      * @property
      * @returns ReportService
      */
     public static get instance(): ReportService
     {
         if(!this._instance)
         {
             this._instance = new ReportService();
         }
         
         return this._instance;
    }

    
    /**
     * 获取报告列表
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getPhysicalReportList(data: any): Promise<IHttpResponse>
    {

        let response = await this.apis.physicalReportList({
            data: data
        });

        return response;
    }

    /**
     * 获取报告数量
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getUnReadReportNum(): Promise<IHttpResponse>
    {
        let response = await this.apis.getUnReadReportNum({});
        return response;
    }

    /**
     * 获取报告详情
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async physicalReportDetail(id: any): Promise<IHttpResponse>
    {

        let response = await this.apis.physicalReportDetail({
            data:{id}
        });

        return response;
    }

    /**
     * 上传体检报告
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async uploadReport(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.uploadReport({
            data: data,
            serializeType:"form-data"
        });

        return response;
    }

    /**
     * 继续上传体检报告
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async proceedUploadReport(data: any): Promise<IHttpResponse>
    {

        let response = await this.apis.proceedUploadReport({
            data: data
        });

        return response;
    }

    /**
     * 下载体检报告
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async downloadReport(id: any): Promise<IHttpResponse>
    {

        let response = await this.apis.downloadReport({data: {id}});

        return response;
    }

    /**
     * 体检报告登入授权
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async reportLogin(data: any): Promise<IHttpResponse>
    {

        let response = await this.apis.reportLogin({
            data: data
        });

        return response;
    }

    /**
     * 获取品牌列表
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async brandLogList(memberId: any): Promise<IHttpResponse>
    {

        let response = await this.apis.brandLogList({data: {memberId}});

        return response;
    }


    /**
     * 添加品牌
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async addbrandLog(data: any): Promise<IHttpResponse>
    {

        let response = await this.apis.addbrandLog({
            data: data
        });

        return response;
    }

    /**
     * 获取解析列表
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async queryAnalyze(reportId: any): Promise<IHttpResponse>
    {

        let response = await this.apis.queryAnalyze({
            params:{reportId}
        });

        return response;
    }

    /**
     * 取消预约
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async cancelReservation(id: any): Promise<IHttpResponse>
    {

        let response = await this.apis.cancelReservation({ urlPath: { id: id } });

        return response;
    }

    /**
     * 获取ocr解析结果
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getAnalysisResults(reportId:any,memberId: any,): Promise<IHttpResponse>
    {

        let response = await this.apis.getAnalysisResults({
            params:{reportId,memberId}
        });

        return response;
    }

    /**
     * 初始化未解析的体检报告
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async initOCRAnalysis(memberId: any): Promise<IHttpResponse>
    {

        let response = await this.apis.initOCRAnalysis({
            params:{memberId}
        });

        return response;
    }

    /**
     * 客户发送未授权报告验证码
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async sendQueryUnAuth(data): Promise<IHttpResponse>
    {
        let response = await this.apis.sendQueryUnAuth({data});
        return response;
    }

    /**
     * 客户端查询未授权报告
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async queryUnAuth(data): Promise<IHttpResponse>
    {
        let response = await this.apis.queryUnAuth({data});
        return response;
    }

    /**
     * 客户端授权报告
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async authReport(data): Promise<IHttpResponse>
    {
        let response = await this.apis.authReport({data});
        return response;
    }

    /**
     * 获取品牌列表
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getSupplierBrandList(): Promise<IHttpResponse>
    {
        let response = await this.apis.getSupplierBrandList({});
        return response;
    }

    
}
